import { Loader } from '@googlemaps/js-api-loader'

export const googleMaps = () => {

  const mapEl = document.querySelector('#map')

  if (!mapEl) return

  const loader = new Loader({
    apiKey: 'AIzaSyBuMLH7zsvC2njbxlyilqjVLlRp79FyXKQ',
    version: 'weekly',
  }) 

  const mapStyle = [ { "elementType": "geometry", "stylers": [ { "color": "#212121" } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "color": "#212121" } ] }, { "featureType": "administrative", "elementType": "geometry", "stylers": [ { "color": "#757575" } ] }, { "featureType": "administrative.country", "elementType": "labels.text.fill", "stylers": [ { "color": "#9e9e9e" } ] }, { "featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [ { "color": "#bdbdbd" } ] }, { "featureType": "administrative.neighborhood", "elementType": "labels.text.fill", "stylers": [ { "color": "#ffb9db" } ] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#181818" } ] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [ { "color": "#616161" } ] }, { "featureType": "poi.park", "elementType": "labels.text.stroke", "stylers": [ { "color": "#1b1b1b" } ] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [ { "color": "#2c2c2c" } ] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [ { "color": "#8a8a8a" } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#373737" } ] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [ { "color": "#3c3c3c" } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#707070" } ] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [ { "color": "#4e4e4e" } ] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [ { "color": "#616161" } ] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#000000" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#3d3d3d" } ] } ]

  loader.load().then(() => {

    const settings = {
      lat: parseFloat(mapEl.dataset.lat),
      lng: parseFloat(mapEl.dataset.lng),
      zoom: parseFloat(mapEl.dataset.zoom),
      icon: mapEl.dataset.pin
    }

    const map = new google.maps.Map(mapEl, {
      zoom: settings.zoom,  
      center: {
        lat: settings.lat,
        lng: settings.lng
      },
      styles: mapStyle,
	  streetViewControl: false,
	  mapTypeControl: false,
      clickableIcons: false,
    }) 

    const position = {
      lat: settings.lat,
      lng: settings.lng
    }

    const icon = new google.maps.MarkerImage(settings.icon, null, null, null, new google.maps.Size(60, 72))
  
    const marker = new google.maps.Marker({
      position: position,
      icon: icon,
      map: map,
    })
    
  })
  
}

export default () => {}